import { render, staticRenderFns } from "./showPaintComposition.vue?vue&type=template&id=171b6226&scoped=true"
import script from "./showPaintComposition.vue?vue&type=script&lang=js"
export * from "./showPaintComposition.vue?vue&type=script&lang=js"
import style0 from "./showPaintComposition.vue?vue&type=style&index=0&id=171b6226&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171b6226",
  null
  
)

export default component.exports